<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-user-friends</v-icon>
            <span class="px-3">{{ $t('View Supplier Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Supplier') }}</strong>
            </v-flex>

            <v-flex xs6 md6 class="pb-3">
              <div class="caption no-select">{{ $t('Name') }}</div>
              <strong>{{ supplierInfo.vender_name || '-' }}</strong>
            </v-flex>

            <v-flex xs6 md6 class="pb-3">
              <div class="caption no-select">{{ $t('Type') }}</div>
              <strong>{{ $t(supplierInfo.individual_or_company) || '-' }}</strong>
            </v-flex>

            <v-flex xs6 sm6 class="pb-3">
              <div class="caption no-select">{{ $t('Phone') }}</div>
              <strong>{{ supplierInfo.vender_phone || '-' }}</strong>
            </v-flex>

            <v-flex xs6 sm6 class="pb-3">
              <div class="caption no-select">{{ $t('Email') }}</div>
              <strong>{{ supplierInfo.vender_mail || '-' }}</strong>
            </v-flex>

            <v-flex xs4 sm4 class="pb-3">
              <div class="caption no-select">{{ $t('Country') }}</div>
              <strong>{{ returnCountryName(supplierInfo.vender_country) || '-' }}</strong>
            </v-flex>

            <v-flex xs4 sm4 class="pb-3">
              <div class="caption no-select">{{ $t('Governorate') }}</div>
              <strong>{{ supplierInfo.vender_governorate || '-' }}</strong>
            </v-flex>

            <v-flex xs4 sm4 class="pb-3">
              <div class="caption no-select">{{ $t('City') }}</div>
              <strong>{{ supplierInfo.vender_city || '-' }}</strong>
            </v-flex>

            <v-flex xs12 class="pb-3">
              <div class="caption no-select">{{ $t('Address') }}</div>
              <strong v-html="lnToBr(supplierInfo.vender_address) || '-'" />
            </v-flex>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  computed: {
    ...mapGetters({
      supplierInfo: 'suppliers/getSupplierInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    returnCountryName(countryId) {
      return helpers.getCountryName(countryId)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
